import announce from './announce/routes'
import move from './move/routes'
import park from './park/routes'
import scrap from './scrap/routes'
import unpark from './unpark/routes'

const routes = {
  index: {
    path: 'index.maneuver',
    url: 'manoeuvre',
  },
  move,
  park,
  scrap,
  unpark,
  announce,
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/routes.js